type Row = Record<string, unknown>;

/** PHP 8's `layer_value($caster, $key) == 0`: null / false are loosely 0; numeric strings compare as numbers; '' is NOT 0. */
export const looselyZero = (value: unknown): boolean => {
  const v = Array.isArray(value) ? value[0] : value;
  if (v === null || v === undefined || v === false) return true;
  if (typeof v === 'number') return v === 0;
  if (typeof v === 'string') return /^\s*[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?\s*$/.test(v) && Number(v) === 0;
  return false;
};

/** The compile omits empty inventory. Nonzero hand counts or a refusal cannot prove a missing list is empty. */
export function heldInventory(row: Row, value: (row: Row | null, key: string) => unknown): unknown[] | null {
  if (typeof row._inventory_refusal === 'string') return null;
  if (Array.isArray(row.inventory)) return row.inventory;
  return row.inventory === undefined && ['count_main_hand_weapon_equipped', 'count_off_hand_weapon_equipped', 'count_both_hands_weapon_equipped']
    .every(key => looselyZero(value(row, key))) ? [] : null;
}
